import "./homepage.css";
import logoCristinaNuovo from "../../assets/logoCristinaNuovo.png";
import { NavLink,useNavigate } from "react-router-dom";

import Sitemap from "../../config/sitemap.json";
import { Helmet } from "react-helmet";

export const Homepage = () => {
    const nav = useNavigate()
    return (
        <>
            <title>
                <Helmet> Homepage </Helmet>
            </title>
            <section id="homepage" className="container-fluid relative ">
                <span
                    className={`absolute  `}
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasRight"
                    aria-controls="offcanvasRight"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        fill="#0088A3"
                        className="bi bi-list m-2"
                        viewBox="0 0 16 16"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
                        />
                    </svg>
                </span>
                <div
                    className="offcanvas offcanvas-end"
                    tabindex="-1"
                    id="offcanvasRight"
                    aria-labelledby="offcanvasRightLabel"
                >
                    <div className="offcanvas-header ms-2">
                        <h5 className="offcanvas-title textBlue" id="offcanvasRightLabel">
                            Menu
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="offcanvas-body d-flex  justify-content-evenly flex-column py-3 ms-2">
                        {Sitemap.map((el) => {
                            return (
                                
                                    <span
                                        className="textBlue fs-4 underline-none bnt-close"
                                        data-bs-dismiss="offcanvas"
                                        aria-label="Close"
                                        onClick={() => nav(el.link)}
                                    >
                                        {el.name}
                                    </span>
                                
                            );
                        })}
                    </div>
                </div>
                <main className="h-100 d-flex flex-column justify-content-center">
                    <div className="w-full justify-content-center d-flex">
                        <a href="/">
                            <img className="logo" src={logoCristinaNuovo} alt="DoulaCristina" />
                        </a>
                    </div>
                    <div className="container-xl text-center d-flex flex-column justify-content-center justify-self-center pt-5 gap-5">
                        <div className="row">
                            <div className="col-12 textBlue">
                                <h2 className="title corsivo">Doula Cristina</h2>
                                <h3 className="fs-1 corsivo mt-4">
                                    Sostegno in gravidanza, parto e primi mesi del neonato
                                </h3>
                            </div>
                        </div>
                        <div className="row d-flex justify-content-center gap-md-5 mt-md-5 gap-3">
                            <NavLink
                                to="/chi-sono"
                                className="fs-3 p-1 p-sm-2 servizi textBlue col-5 col-md-5 col-lg-3 d-flex justify-content-center flex-column"
                            >
                                Chi Sono
                            </NavLink>

                            <NavLink
                                to="/servizi"
                                className="fs-3 p-1 p-sm-2 servizi textBlue col-5 col-md-5 col-lg-3 d-flex justify-content-center flex-column"
                            >
                                Cosa posso fare per te
                            </NavLink>
                        </div>
                    </div>
                </main>
            </section>
        </>
    );
};
